import { PageShell } from "./PageShell";
import { Differentials } from "./Differentials";
import { FinalCTA } from "./FinalCTA";

export default function DiferenciaisPage() {
  return (
    <PageShell testId="diferenciais-page">
      <div className="pt-[72px]">
        <Differentials />
      </div>
      <FinalCTA />
    </PageShell>
  );
}
